"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * PageQuery
 * @desc - singleton class for the page query string
 * @properties - _data {string} raw location.search string
 *               queryStr {string} decoded query string
 *               keyValStrs {array} array of key value pairs as strings
 * @methods - getAsObject() returns object of key value pairs
 *            getValue(key) returns the value of key arg
 *            getKeys() returns array of keys
 *            makeString(params) takes object and returns query string
 */
var PageQuery = function () {
    function PageQuery() {
        _classCallCheck(this, PageQuery);

        if (!PageQuery.instance) {
            this._data = window.location.search;
            this.queryStr = this._data.length > 1 ? decodeURIComponent(this._data.substring(1, this._data.length)) : '';
            this.keyValStrs = [];
            if (this._data) {
                for (var i = 0; i < this.queryStr.split("&").length; i++) {
                    this.keyValStrs[i] = this.queryStr.split("&")[i];
                }
            }
            PageQuery.instance = this;
        }
        return PageQuery.instance;
    }

    _createClass(PageQuery, [{
        key: "getAsObject",
        value: function getAsObject() {
            var obj = {};
            for (var j = 0; j < this.keyValStrs.length; j++) {
                obj[this.keyValStrs[j].split("=")[0]] = this.keyValStrs[j].split("=")[1];
            }
            return obj;
        }
    }, {
        key: "getValue",
        value: function getValue(key) {
            for (var j = 0; j < this.keyValStrs.length; j++) {
                if (this.keyValStrs[j].split("=")[0] === key) {
                    return this.keyValStrs[j].split("=")[1];
                }
            }
            return false;
        }
    }, {
        key: "getKeys",
        value: function getKeys() {
            var a = [];
            for (var j = 0; j < this.keyValStrs.length; j++) {
                a[j] = this.keyValStrs[j].split("=")[0];
            }
            return a;
        }
    }, {
        key: "makeString",

        /*
         * make a query string from a params object
         * {Object} params -- object to convert into a query string
         * return {String} query string
         */
        value: function makeString(params) {
            return "?" + Object.keys(params).map(function (k) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
            }).join('&');
        }
    }]);

    return PageQuery;
}();
var instance = new PageQuery();
Object.freeze(instance);
exports.default = instance;